import React from "react";
import { useSelector } from "react-redux";

import SubmitButton from "components/Button/SubmitButton";
import useNoteButtonActionInProgress from "../../hooks/useNoteButtonActionInProgress";

const BUTTON_PROPS = {
  contained: { variant: "contained", color: "secondary" },
  outlined: { variant: "outlined", color: "secondary" },
  link: {
    variant: "text",
    color: "inherit",
    size: "small",
    getStyles: () => ({ textDecoration: "underline" }),
  },
  danger: {
    variant: "contained",
    color: "secondary",
    getStyles: (isDisabled) => ({
      color: "white",
      backgroundColor: isDisabled ? "rgba(0, 0, 0, 0.26)" : "#f44336",
    }),
  },
};

const FooterButton = ({
  kind = "contained",
  label,
  icon,
  dataAction,
  onClick,
  isLoading = false,
  disabled = false,
}) => {
  const isActionInProgress = useNoteButtonActionInProgress();
  const isDisabled = disabled || isActionInProgress;
  const { getStyles, ...buttonProps } = BUTTON_PROPS[kind];

  return (
    <SubmitButton
      className="view-pdf__notes-footer__button"
      {...buttonProps}
      style={getStyles?.(isDisabled)}
      buttonText={label}
      startIcon={icon}
      data-action={dataAction}
      handleClick={onClick}
      isLoading={isLoading}
      disabled={isDisabled}
    />
  );
};

export const ProcessButton = ({ onClick, isLoading, disabled }) => {
  const { isReportProcessing } = useSelector((state) => state.transmission);

  return (
    <FooterButton
      label="Process"
      dataAction="process-button"
      onClick={onClick}
      isLoading={isLoading || isReportProcessing}
      disabled={disabled}
    />
  );
};

export const UnprocessButton = ({ onClick }) => {
  const { isReportUnProcessing } = useSelector((state) => state.transmission);

  return (
    <FooterButton
      kind="outlined"
      label="Unprocess"
      dataAction="unprocess-button"
      onClick={onClick}
      isLoading={isReportUnProcessing}
    />
  );
};

export default FooterButton;
